// extracted by mini-css-extract-plugin
module.exports = {"content":"FaqContent_content__S1RPe","category":"FaqContent_category__1-MS5","tab":"FaqContent_tab__1ZUkC","isActive":"FaqContent_isActive__378Xm","list":"FaqContent_list__3KRWj"};